import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'sku-orders.missed-pickup-modal.title',
    defaultMessage: 'Customer missed pickup',
  },
  body: {
    id: 'sku-orders.missed-pickup-modal.body',
    defaultMessage: 'This will cancel the order and mark it as a customer missed pickup.',
  },
  confirm: {
    id: 'sku-orders.missed-pickup-modal.confirm',
    defaultMessage: 'Cancel order',
  },
});
